import React, { useState } from 'react'

import User from '../models/User'

import messages from '../data/messages'

import { useMedicareAuthFlow } from '../hooks/useMedicareAuthFlow'

import { GlobalHeader } from '../components/GlobalHeader/GlobalHeader'
import { MessageCenterModal } from '../components/MessageCenterModal/MessageCenterModal'

interface HeaderProps {
  languageToggleLink: string;
  loginUrl: string;
  logoutUrl: string;
  enableLiveChat: boolean
}

const Header: React.FC<HeaderProps> = ({ languageToggleLink, loginUrl, logoutUrl, enableLiveChat = true }) => {
  const [modal, setModal] = useState<any>()
  const user: User | undefined = useMedicareAuthFlow() // Call sls and get a user back if they're already logged in

  const openMessageCenter = () => {
    setModal(<MessageCenterModal messages={messages} onClose={() => setModal(undefined)} />)
  }

  return (
    <>
      {modal || ''}
      <GlobalHeader
        user={user}
        messages={messages}
        loginUrl={loginUrl}
        logoutUrl={logoutUrl}
        onViewMoreMessagesClick={openMessageCenter}
        languageToggleLink={languageToggleLink}
        enableLiveChat={enableLiveChat}
      />
    </>
  )
}

export default Header
